<template>
  <div class="app flex-row align-items-center bg-img" :style="backgroundImage" style="background-size:cover">
    <div class="container">
      <div v-if="positionScreen" class="row" :class="'justify-content-' + positionScreen">
        <div class="col-md-5">
          <div class="card-group mb-0">
            <div class="card p-4" style="height: 500px; border-radius: 10px;">
              <div class="col login-block-logo text-center">
                <img :src="logoImage" style="width: 240px" />
              </div>
              <LostPassword v-if="resetPass" @BackToLogin="backToLogin"></LostPassword>
              <LoginScreen v-else-if="login" @Login="validateAndSignIn" @ResetPassword="resetPassword"></LoginScreen>
              <MfaScreen v-else @LoginMFA="validateAndVerifyMFA"></MfaScreen>
              <div class="row justify-content-left pt-3"  style="position:absolute; top:360px; left: 50px;">
                <a href="http://nexum.com.br" target="_blank"  style="color: #04A791;">Plataforma nxCoop <br /> {{$lang.Login.LabelVersion}} {{version}} <br /> Uso autorizado para {{nomeCliente}}</a>
              </div>
              <div class="col login-bottom-logo text-right">
                <img src="/static/img/logotipo/logo.svg" style="width: 150px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { loading, toast } from '@/shared/utils/UIHelper'
import LoginScreen from './login/login.vue'
import EnvironmentRepository from '@/shared/http/repositories/access/environment'
import MfaScreen from './mfa/mfa.vue'
import { mapActions } from 'vuex'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'
import SignInMixin from '@/store/module/signIn/mixin.js'
import LostPassword from './lost/LostPassword.vue'

export default {
  data () {
    return {
      nomeCliente: process.env.Nome_Cooperativa,
      version: process.env.VersionApp,
      backgroundImage: null,
      logoImage: null,
      positionScreen: null,
      login: true,
      resetPass: false
    }
  },
  components: {
    LoginScreen,
    MfaScreen,
    LostPassword
  },
  mixins: [
    SignInMixin
  ],
  created () {
    this.getImageAndLogo()
  },
  methods: {
    ...mapActions({
      signIn: authActions.SIGN_IN
    }),
    validateAndSignIn (user, pass) {
      this.credentials.username = user
      this.credentials.password = pass
      this.credentials.authCode = undefined
      this.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.signIn(this.credentials)
              .then((success, res) => {
                if (success) {
                  this.$router.push({ name: 'PaginaInicial' })
                }
              })
              .catch((error) => {
                if (error.data.headers.step && error.data.headers.step === 'authCode') {
                  this.login = false
                } else {
                  toast.error(this.$lang.Login.InvalidCredentials)
                }
              })
          }
        })
    },
    validateAndVerifyMFA (mfa) {
      this.credentials.authCode = mfa
      this.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.signIn(this.credentials)
              .then((success, res) => {
                if (success) {
                  this.$router.push({ name: 'PaginaInicial' })
                }
              })
              .catch((e) => {
                toast.error(this.$lang.Login.InvalidCredentials)
              })
          }
        })
    },
    getImageAndLogo () {
      loading.push()
      EnvironmentRepository.getEnv()
        .then((response) => {
          this.setBackgroudImage(response.data.hasBackground)
          this.setPosicaoModal(response.data.posicao)
          this.setLogo(response.data.hasLogo)
          loading.pop()
        })
        .catch(() => {
          this.setDefaultEnv()
          loading.pop()
        })
    },
    setBackgroudImage (hasBackground) {
      if (!hasBackground) {
        this.backgroundImage = 'background-image: url("/static/img/bg/bg-01.jpg")'
      } else {
        this.backgroundImage = 'background-image: url("' + process.env.APIBaseURLCore + '/environment/background' + '")'
      }
    },
    setPosicaoModal (posicao) {
      if (posicao === 'DIREITA') {
        this.positionScreen = 'end'
      } else if (posicao === 'CENTRO') {
        this.positionScreen = 'center'
      } else {
        this.positionScreen = 'start'
      }
    },
    setLogo (hasLogo) {
      if (!hasLogo) {
        this.logoImage = '/static/img/logotipo/logo-branco.svg'
      } else {
        this.logoImage = process.env.APIBaseURLCore + '/environment/logo'
      }
    },
    setDefaultEnv () {
      this.backgroundImage = 'background-image: url("/static/img/bg/bg-01.jpg")'
      this.logoImage = '/static/img/logotipo/logo-branco.svg'
      this.positionScreen = 'start'
    },
    resetPassword () {
      this.resetPass = true
      this.login = false
    },
    backToLogin () {
      this.resetPass = false
      this.login = true
    }
  }
}
</script>

<style scoped>

  #LoginScreen, #MfaScreen{
    position: relative;
    top: 300px;
  }
  .card{
    background: linear-gradient(to bottom, #04A791 0%, #04A791 20%, white 20%, white 72%, #F5F5F5 72%, #F5F5F5 100%);
  }
  .login-block-logo{
    position: absolute;
    top: 15px;
  }
  .login-bottom-logo{
    position: absolute;
    top: 450px;
    left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/public/auth/Authentication.vue